import { FC, ReactNode, useState } from 'react';
import { ModalContext } from 'shared/lib/modal';

interface ModalProviderProps {
	children: ReactNode;
	openByDefault?: boolean;
}

export const ModalProvider: FC<ModalProviderProps> = ({
	children,
	openByDefault = false,
}) => {
	const [isOpen, setIsOpen] = useState(openByDefault);

	const openModal = () => setIsOpen(true);
	const closeModal = () => setIsOpen(false);

	return (
		<ModalContext.Provider value={{ openModal, closeModal, isOpen }}>
			{children}
		</ModalContext.Provider>
	);
};
